import Link from "next/link";
import TaleOfTheTapeInfoItem from "./TaleOfTheTapeInfoItem";
import CandidateInfoSnippet from "../../candidate/parts/CandidateInfoSnippet";
import styles from "../../../styles/races/national/TaleOfTheTapeInfoContent.module.scss";

const TaleOfTheTapeInfoContent = ({
  type,
  items,
  selectedCandidates,
  scrollHandler,
}) => {
  return (
    <div className={styles.infoContent}>
      <div className={styles.stickyContainer}>
        {items.label && <div className={styles.header}>{items.label}</div>}
        <div
          className={styles.content}
          data-tott-scroller
          data-tott-scroller-type={type}
          onScrollCapture={scrollHandler}
        >
          {items.content.map((item, index1) => {
            return (
              <div
                key={index1}
                className={`${styles.column} ${
                  type === "bio" ? styles.italicized : ""
                }`}
              >
                {Object.keys(selectedCandidates[index1]).length > 0 &&
                (item === undefined || item.length === 0) ? (
                  <TaleOfTheTapeInfoItem
                    key={index1}
                    item={{ content: "No information." }}
                  />
                ) : (
                  item?.map((ic, index2) => {
                    if (ic !== "") {
                      if (
                        type === "bio" ||
                        type === "highlights-controversies"
                      ) {
                        return (
                          <>
                            <TaleOfTheTapeInfoItem key={index2} item={ic} />
                            {ic.source && ic.source.url && (
                              <div className={styles.footNote}>
                                <p>
                                  <Link href={ic.source.url} passHref>
                                    {ic.source.date}
                                  </Link>
                                </p>
                              </div>
                            )}
                          </>
                        );
                      } else {
                        if (ic !== undefined) {
                          return (
                            <>
                              <CandidateInfoSnippet
                                key={index2}
                                header={ic.header}
                                details={ic.details}
                                context={ic.context}
                                positionStrength={ic.positionStrength}
                                showSocials={false}
                                isSmall
                                isPosition={type === "stances"}
                                showTitleInside={type === "stances"}
                              />
                              {ic.source && ic.source.url && (
                                <div className={styles.footNote}>
                                  <p>
                                    Source&nbsp;
                                    <Link href={ic.source.url} passHref>
                                      {ic.source.text}
                                    </Link>
                                  </p>
                                </div>
                              )}
                            </>
                          );
                        } else {
                          return (
                            <TaleOfTheTapeInfoItem
                              key={index2}
                              item={{ content: "No information." }}
                            />
                          );
                        }
                      }
                    } else {
                      return (
                        <TaleOfTheTapeInfoItem
                          key={index2}
                          item={{ content: "No information." }}
                        />
                      );
                    }
                  })
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TaleOfTheTapeInfoContent;
